import type { Utility } from "@cs2/contracts";
import { grenadeGlyphs } from "./grenade-paths.js";

/** Gemeinsames SVG-Symbol für Tools-Menü, Inspector und Quickview-Utility-Liste. */
export function GrenadeIcon({ type }: { type: Utility["type"] }) {
  const glyph = grenadeGlyphs[type];
  return (
    <svg
      viewBox={`0 0 ${glyph.viewBox} ${glyph.viewBox}`}
      fill="none"
      aria-hidden="true"
    >
      {glyph.paths.map((path) => (
        <path
          key={path.d}
          fill="currentColor"
          d={path.d}
          opacity={path.opacity}
          fillRule={path.fillRule}
          clipRule={path.fillRule ? "evenodd" : undefined}
        />
      ))}
    </svg>
  );
}
